export default __webpack_public_path__ + "static/media/loginrelatoriodeobras.1b42e6f6.jpg";